/**
 * The glyphs a lesson's journey stars are drawn with. Every lesson counts 25 stars; the event
 * lessons dress them up — Halloween counts spiders instead, filling a web — so the glyphs follow
 * the LESSON, not the calendar: another lesson played during the event keeps its stars.
 *
 * Pure data and Phaser-free. Callers resolve it at render time (never at module load), because the
 * active lesson changes without a reload.
 */
export interface StarGlyphs {
  full: string;
  empty: string;
  /** Text colour of a filled glyph — ignored by colour emoji, which carry their own. */
  fullColor: string;
  emptyColor: string;
  /** Soft halo behind a glyph (colour emoji only), so a dark spider reads on the dark menu. */
  halo?: string;
}

export const STARS: StarGlyphs = { full: '★', empty: '☆', fullColor: '#ffd166', emptyColor: '#3a3f47' };

/** 🕷️ and 🕸️ with the emoji variation selector, so no platform draws them as flat text. */
export const SPIDERS: StarGlyphs = {
  full: '\u{1F577}️', empty: '\u{1F578}️', fullColor: '#ff9a1f', emptyColor: '#3a3f47', halo: '#ff9a1f',
};

/** Journey pool ids that count spiders. */
const SPIDER_POOLS: readonly string[] = ['halloween'];

export function starGlyphsFor(pack: { id: string } | null | undefined): StarGlyphs {
  return isHalloweenPack(pack) ? SPIDERS : STARS;
}

/**
 * True for the Halloween event lesson. Everything that dresses up the round for it — the spooky
 * backdrop, the flying ghost, the candle, the spider that replaces the ladybird, the spiders that
 * replace the stars — asks this one question, so another lesson played during the event looks
 * exactly as it always does.
 */
export function isHalloweenPack(pack: { id: string } | null | undefined): boolean {
  return !!pack && SPIDER_POOLS.includes(pack.id);
}
